import { getCurrentFirebaseUser } from './client'
import { getHanaspeakApiBaseUrl } from './functions-api'

export interface EnsureLearnerTrialResult {
  readonly activationCode: string
  readonly endAt: number | null
  readonly granted: boolean
  readonly reason: 'already-trial' | 'granted' | 'has-access'
  readonly trialDays: number
}

export async function ensureLearnerTrial(): Promise<EnsureLearnerTrialResult> {
  const user = getCurrentFirebaseUser()

  if (!user) {
    throw new Error('Not authorized')
  }

  const idToken = await user.getIdToken()
  const response = await fetch(`${getHanaspeakApiBaseUrl()}/learner/trial/ensure`, {
    body: JSON.stringify({}),
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })
  const payload = await response.json().catch(() => null) as Partial<EnsureLearnerTrialResult> & {
    readonly error?: unknown
  } | null

  if (!response.ok) {
    const message = typeof payload?.error === 'string' ? payload.error : 'Unable to start the free trial right now.'
    throw new Error(message)
  }

  if (typeof payload?.activationCode !== 'string' || !payload.activationCode) {
    throw new Error('Trial response did not include an activation code.')
  }

  return {
    activationCode: payload.activationCode,
    endAt: typeof payload.endAt === 'number' ? payload.endAt : null,
    granted: payload.granted === true,
    reason: payload.reason === 'granted' || payload.reason === 'has-access' ? payload.reason : 'already-trial',
    trialDays: typeof payload.trialDays === 'number' ? payload.trialDays : 14,
  }
}

export async function ensureLearnerTrialSafe(): Promise<EnsureLearnerTrialResult | null> {
  try {
    return await ensureLearnerTrial()
  } catch (error) {
    console.warn('Learner trial ensure failed', error)
    return null
  }
}
